import { Instance } from 'mobx-state-tree';
import { RouteTemplatesDtoModelBase } from './RouteTemplatesDtoModel.base';

/* The TypeScript type of an instance of RouteTemplatesDtoModel */
export interface RouteTemplatesDtoModelType extends Instance<typeof RouteTemplatesDtoModel.Type> {}

/* A graphql query fragment builders for RouteTemplatesDtoModel */
export { selectFromRouteTemplatesDto, routeTemplatesDtoModelPrimitives, RouteTemplatesDtoModelSelector } from './RouteTemplatesDtoModel.base';

/**
 * RouteTemplatesDtoModel
 */
export const RouteTemplatesDtoModel = RouteTemplatesDtoModelBase
  .views(self => ({
    get tagNames(): string[] {
      return self.constraints?.tags?.map((tag: { name: any }) => tag.name).filter((name: any): name is string => !!name) ?? [];
    },
  }))
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
